import React from 'react'
import input from '../../../assets/json/inputs/config-home'
import BreadCrumb from '../../../components/breadcrumb/BreadCrumb';
import styles from './home.module.scss'

function Home(props) {

    const breadcrumbList = [
        {
            value: "Dashboard",
            path: "/dashboard",
        },
        {
            value: "Configuration",
            path: "/",
        },
    ];

    const onClick = (element) => {
        props.history.push(element.url)
    }

    return (
        <div className={styles.container}>
            <BreadCrumb
                list={breadcrumbList}
                {...props}
                hideFavorite={true}
            />
            <div className={styles.listcontainer}>
                {
                    input.map((element, index) => (
                        <div className={styles.dataCardWrapper} key={index} >
                            <div className={styles.dataCard}>
                                <div className={styles.headerKpi}>{element.label}</div>
                                {
                                    element.values.map((_element, index) => (
                                        <div onClick={() => onClick(_element)} className={styles.chieldKpi} key={index} >{_element.label}
                                            <div className={styles.arrowLeft}></div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Home